export default __webpack_public_path__ + "static/media/Instigador.f7441ca4.svg";